import React from "react";

export default function LoadingAnimation(){
    return (
        <div className="loading-animation">
            <div className="bg-main-green-500"></div>
            <div className="bg-main-green-500"></div>
            <div className="bg-main-green-500"></div>
        </div>
    )
}